<mat-expansion-panel>
  <mat-expansion-panel-header>
    <mat-panel-title>
      Filter
    </mat-panel-title>
    <mat-panel-description>
      Showing only events&nbsp;
      <span *ngIf="filterInstructorCategoryVal"> for {{ getNameFromId(filterInstructorCategoryVal, filterInstructorCategory, 'name') }} Instructors&nbsp;</span>
      <span *ngIf="filterLessonTypeVal"> for {{ getNameFromId(filterLessonTypeVal, filterLessonType) }} Lessons</span>
      <span *ngIf="filterStudent"> for {{ filterStudent }}&nbsp;</span>
      <span *ngIf="filterGroupLesson || filterLesson || filterServices">
        that are
        <span *ngIf="filterGroupLesson"> Group Lessons </span>
        <span *ngIf="filterLesson"> Personal Lessons </span>
        <span *ngIf="filterServices"> Services </span>
        &nbsp;
      </span>
      <span *ngIf="filterDate">&nbsp;on {{ filterDate | date:displayDateFormatAngular }}</span>
    </mat-panel-description>
  </mat-expansion-panel-header>

  <form (ngSubmit)="onSubmit(filterForm)" #filterForm="ngForm" class="form">
    <div class="row">
    <!-- <p *ngFor="let lesson of filterLessonType" class="{{lesson.id}}">
        {{lesson.value}}
    </p> -->
        <div class="col-12 col-sm-6 col-lg">
            <mat-form-field class="full-width-field">
                <mat-label>Instructor Category</mat-label>
                <mat-select
                    name="filterInstructorCategory"
                    [(ngModel)]="filterInstructorCategoryVal"
                    (selectionChange)="onSubmit(filterForm)"
                    >
                    <mat-option>None</mat-option>
                    <mat-option *ngFor="let value of filterInstructorCategory" [value]="value.id">{{value.name}}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div class="col-12 col-sm-6 col-lg">
            <!-- <mat-form-field appearance="standard">
                <mat-label>Select Instructor</mat-label>
                <mat-select
                    name="filterInstructor"
                    [(ngModel)]="filterInstructor">
                    <mat-option *ngFor="let value of filterInstructor" [value]="value.name">{{value.name}}</mat-option>
                </mat-select>
            </mat-form-field> -->

            <mat-form-field class="full-width-field">
                <mat-label>Choose Lesson Type..</mat-label>
                <mat-select
                    (selectionChange)="onSubmit(filterForm)"
                    [(ngModel)]="filterLessonTypeVal"
                    name="filterLessonType">
                    <mat-option>None</mat-option>
                    <mat-option
                    *ngFor="let element of taxonomyService.lesson_type"
                        [value]="element.id">{{ element.name }}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>


        <div class="col-12 col-sm-6 col-lg">

            <mat-form-field class="full-width-field">
                <mat-label>Student</mat-label>
                <input
                    #studentInput
                    name="filterStudent"
                    (input)="onStudentInput($event)"
                    matInput
                    [(ngModel)]="filterStudent"
                    [matAutocomplete]="auto"
                    >
                    <button type="button" matSuffix mat-icon-button aria-label="manage_accounts" (click)="openStudentDashboard($event)">
                        <mat-icon>manage_accounts</mat-icon>
                    </button>
            </mat-form-field>
            <mat-autocomplete #auto="matAutocomplete"
                    (optionSelected)="onSubmit(filterForm)">
                <mat-option *ngFor="let option of autoCompleteOptions"
                    [value]="option.label + ' ' + '(' + option.value + ')'">
                    {{option.label}} ({{option.value}})
                </mat-option>
            </mat-autocomplete>
        </div>


          <div class="col-12 col-sm-6 col-lg">
            <mat-form-field class="full-width-field">
              <mat-label>Choose a date</mat-label>
              <input #flatpickrInput matInput type="text" [value]="filterDate | date:displayDateFormatAngular" readonly>
              <button matSuffix mat-icon-button type="button" (click)="openFlatpickr()">
                <mat-icon>calendar_today</mat-icon>
              </button>
            </mat-form-field>
          </div>


    </div>

    <section class="section mt-3">
        <mat-checkbox
            name="filterGroupLesson"
            class="margin"
            [(ngModel)]="filterGroupLesson"
            (change)="onSubmit(filterForm)">Show Group Lessons</mat-checkbox>
        <mat-checkbox
            name="filterLesson"
            class="margin"
            [(ngModel)]="filterLesson"
            (change)="onSubmit(filterForm)">Show Lessons</mat-checkbox>

        <mat-checkbox
            name="filterServices"
            class="margin"
            [(ngModel)]="filterServices"
            (change)="onSubmit(filterForm)">Show Services</mat-checkbox>

        <mat-checkbox
            name="filterHiddenEvents"
            class="margin"
            [(ngModel)]="filterHiddenEvents"
            (change)="onSubmit(filterForm)">Show Hidden Events</mat-checkbox>
    </section>
<!--
    <mat-divider></mat-divider>
    <button type="submit"
        mat-raised-button
        color="primary">Filter</button> -->

</form>

</mat-expansion-panel>
